import { render } from "./GSCReader.vue?vue&type=template&id=0c642f11"
import script from "./GSCReader.vue?vue&type=script&lang=js"
export * from "./GSCReader.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__